(function() {


  
$(".gb-click-banner-btn-link").click(function(){
     var get_url =  $(this).attr("ahref");
     window.location.href = get_url;
}); 
$(".gb-click-coll-link").click(function(){
     var get_url =  $(this).attr("ahref");
     window.location.href = get_url;
});   

  
$('.our-customer-slider').slick({
        infinite: false,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        prevArrow: $('.our-customer-slider-prev'),
        nextArrow: $('.our-customer-slider-next'),
		 responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
    }
  }]
});   




$('.collection-list').each(function(){  
      var highestBox = 0;
      $('.card__caption', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.card__caption',this).height(highestBox);
    }); 


$(".new-annoucement-bar").slick({
	dots: false,
	fade: true,
    dragable: false,
	pauseOnHover: false,
	arrows: false,
    centerMode: true,
	infinite: true,
	autoplay: true,
	autoplaySpeed: 4000,
	speed: 300,
	slidesToShow: 1,
    slidesToScroll: 1,
	adaptiveHeight: true
});
  $(".new-annoucement-bar-text-main").css({"opacity": "1"});
  
//$('.new-annoucement-bar-toggle').click( function() {
$('body').on('click', '.new-annoucement-bar-toggle', function(){
  var get_attr =  $(this).attr("pause");
  if ( get_attr == 0 ){ 
      $('.new-annoucement-bar-toggle').attr("pause", "1");
      $('.new-annoucement-bar').slick('slickPause');  
      $(this).html('<svg width="11px" height="13px" viewBox="0 0 11 13" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>iconfinder_211876_play_icon</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="iconPlay" fill="#FFFFFF" fill-rule="nonzero" transform="translate(-0.000000, 0.000000)"><path d="M10.4677083,5.71796875 L1.04270833,0.108333333 C0.927604167,0.040625 0.809114583,0 0.673697917,0 C0.3046875,0 0.00338541667,0.3046875 0.00338541667,0.677083333 L0,0.677083333 L0,12.3229167 L0.00338541667,12.3229167 C0.00338541667,12.6953125 0.3046875,13 0.673697917,13 C0.8125,13 0.927604167,12.9526042 1.05286458,12.8848958 L10.4677083,7.28203125 C10.6911458,7.09583333 10.8333333,6.81484375 10.8333333,6.5 C10.8333333,6.18515625 10.6911458,5.90755208 10.4677083,5.71796875 Z" id="Path"></path></g></g></svg>') 
 } else {  
     $('.new-annoucement-bar-toggle').attr("pause", "0");
     $('.new-annoucement-bar').slick('slickPlay');
     $(this).html('<svg width="11px" height="14px" viewBox="0 0 11 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>iconfinder_211871_pause_icon</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="iconPause" fill="#FFFFFF" fill-rule="nonzero"><path d="M4,13.0710937 L4,0.425390625 C4,0.18984375 3.775,0 3.49166667,0 L0.508333333,0 C0.225,0 0,0.18984375 0,0.425390625 L0,13.0710937 C0,13.3066406 0.225,13.5 0.508333333,13.5 L3.49166667,13.5 C3.775,13.5 4,13.3101562 4,13.0710937 Z" id="Path"></path><path d="M10.4916667,0 L7.50833333,0 C7.22916667,0 7,0.18984375 7,0.425390625 L7,13.0710937 C7,13.3066406 7.225,13.5 7.50833333,13.5 L10.4916667,13.5 C10.7708333,13.5 11,13.3101562 11,13.0710937 L11,0.425390625 C11,0.18984375 10.775,0 10.4916667,0 Z" id="Path"></path></g></g></svg>') 
 }  
});  

$('.gb-related-product').slick({
        infinite: false,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
       // prevArrow: $('.our-customer-slider-prev'),
       // nextArrow: $('.our-customer-slider-next'),
		 responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
    }
  }]
});   


 

  
  $('body').on('click', '.gb-radio-buttons-div1', function(){
     $('.gb-size-inches').show();
     $('.gb-radio-buttons-input1').prop('checked', true);
     $('.gb-size-cm').hide();
     $('.gb-radio-buttons-input2').prop('checked', false);
  });
  $('body').on('click', '.gb-radio-buttons-div2', function(){
     $('.gb-size-cm').show();
     $('.gb-radio-buttons-input2').prop('checked', true);
     $('.gb-size-inches').hide();
     $('.gb-radio-buttons-input1').prop('checked', false);
  });

  $("header-menu details").mouseover(function(){
        $("header-menu details").removeAttr("open");
        $("header-menu details").find('summary').attr("aria-expanded", 'true');
        $(this).attr("open" , "rem");
        $(this).find('summary').attr("aria-expanded", 'true');
    });
    $("a.header__menu-item").mouseover(function(){
        $("header-menu details").removeAttr("open");
        $("header-menu details").find('summary').attr("aria-expanded", 'true');
    });
    $("header").mouseleave(function(){
        $( this ).find("details").removeAttr("open");
        $( this ).find('summary').attr("aria-expanded", 'false');
    });


 
      $('body').on('change', '.complete-select-size', function(){ 
           var get_id = $(this).val();
           $(this).closest(".gb-quick-add-main-complete").find(".product-variant-id").val(get_id);
      });


       $('body').on('click', '.gb-col-swatch-main a', function(){ 
         
           $(this).closest(".gb-card-product").find('.rq-hover-change-image').removeClass('pl-swatches__swatch-wrapper--active');  
           $(this).find('.rq-hover-change-image').addClass('pl-swatches__swatch-wrapper--active'); 
        
          var currentCurrency = $(this).attr('curr_symbol');
          var $t = $(this);
          var get_pro_handle = $(this).attr('pro_handle');

         $.ajax({
            dataType: "json",
            url: '/products/'+get_pro_handle+'.js',
            success: function(product){
               var title_img = product.featured_image;
               var title_get = product.title;
               var title_link = product.url;
               var get_pro_price_com = Shopify.formatMoney(product.price).replace('$', currentCurrency);
               var get_pro_price_regular_blank = product.compare_at_price;
               if(get_pro_price_regular_blank) {
                 var get_pro_price_regular = Shopify.formatMoney(product.compare_at_price).replace('$', currentCurrency);
               }
               $t.closest(".gb-card-product").find(".gb_card_media img").attr('srcset', title_img);
               $t.closest(".gb-card-product").find(".gb-add-title-click").html(title_get);
               $t.closest(".gb-card-product").find(".card__content a").attr('href', title_link);
               $t.closest(".gb-card-product").find(".card-information .price .price__container").html('<div class="gb-col-swatch-price-main"><div class="gb-col-regular" hide_undefined="'+get_pro_price_regular+'">'+get_pro_price_regular+'</div><div class="gb-col-compare">'+get_pro_price_com+'</div>');
            }
          });

        
         
       });


  function gsapAccordion() {
              let groups = gsap.utils.toArray(".accordion-group");
              let menus = gsap.utils.toArray(".accordion-menu");
              let menuToggles = groups.map(createAnimation);
              
              menus.forEach((menu) => {
                menu.addEventListener("click", () => toggleMenu(menu));
              });
            
              function toggleMenu(clickedMenu) {
                menuToggles.forEach((toggleFn) => toggleFn(clickedMenu)); // Remove active class from child elements
                menus.filter(menu => menu !== clickedMenu).forEach(menu => { 
                  menu.closest('.accordion-group').querySelector('.accordion-menu').classList.remove('active'); 
                }); 
                // Toggle the active class on clicked menu
                let parentMenu = clickedMenu.closest('.accordion-group').querySelector('.accordion-menu');
                parentMenu.classList.toggle('active'); 
              } 
            
              function createAnimation(element) { 
                let menu = element.querySelector(".accordion-menu"); 
                let box = element.querySelector(".accordion-content"); 
                let minusElement = element.querySelector(".accordion-minus"); 
                let plusElement = element.querySelector(".accordion-plus"); 
                
                gsap.set(box, { height: "auto" }); 
                let animation = gsap.timeline() 
                  .from(box, { height: 0, duration: 0.5, ease: "power1.inOut" }) 
                  .from(minusElement, { duration: 0.2, autoAlpha: 0, ease: "none" }, 0) 
                  .to(plusElement, { duration: 0.2, autoAlpha: 0, ease: "none" }, 0) 
                  .reverse(); 
                
                return function (clickedMenu) { 
                  if (clickedMenu === menu) { 
                    animation.reversed(!animation.reversed()); 
                  } else { 
                    animation.reverse(); 
                  } 
                }; 
              } 
            } 
            
            gsapAccordion();

 
/*GB! free product added STARTS*/ 
var amount_free_product = 7500;
   setTimeout(function () {
      var cart_total = $('.gb-totals-total-value').text(); 
      if(cart_total >= amount_free_product ) { 
         if($(".cart-item").hasClass("gb-find-remove-product")) {
         }else{
           $('.gb-free-product-tirgger').trigger('click'); 
         }
          
       } else {
          $('.gb-remove-product').trigger('click');  
       }
    }, 3000);  
$('body').on('click', '.gb-sumbit-free', function(){
   var amount_free_product = 7500;
   setTimeout(function () {
      var cart_total = $('.gb-totals-total-value').text(); 
      if(cart_total >= amount_free_product ) { 
         if($(".cart-item").hasClass("gb-find-remove-product")) {
         }else{
           $('.gb-free-product-tirgger').trigger('click'); 
         }
          
       } else {
          $('.gb-remove-product').trigger('click');  
       }
    }, 3000);
     
});
$('body').on('click', '.quantity__button', function(){
   var amount_free_product = 7500;
   setTimeout(function () {
      var cart_total = $('.gb-totals-total-value').text(); 
      if(cart_total >= amount_free_product ) { 
         if($(".cart-item").hasClass("gb-find-remove-product")) {
         }else{
           $('.gb-free-product-tirgger').trigger('click'); 
         }
       } else {
          $('.gb-remove-product').trigger('click');  
       }
    }, 3000);
     
}); 
$('body').on('keyup', '.quantity__input', function(){
   var amount_free_product = 7500;
   setTimeout(function () {
      var cart_total = $('.gb-totals-total-value').text(); 
      if(cart_total >= amount_free_product ) { 
         if($(".cart-item").hasClass("gb-find-remove-product")) {
         }else{
           $('.gb-free-product-tirgger').trigger('click'); 
         }
       } else {
          $('.gb-remove-product').trigger('click');  
       }
    }, 3000);
     
});
$('body').on('click', '.cart-remove-button', function(){
   var amount_free_product = 7500;
   setTimeout(function () {
      var cart_total = $('.gb-totals-total-value').text(); 
      if(cart_total >= amount_free_product ) { 
         if($(".cart-item").hasClass("gb-find-remove-product")) {
         }else{
           $('.gb-free-product-tirgger').trigger('click'); 
         } 
       } else {
          $('.gb-remove-product').trigger('click');  
       }
    }, 3000);
     
});   
  
})();